import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import auth from './middleware/auth'
import scheduled from './middleware/scheduled'
import middlewarePipeline from './middlewarePipeline'

Vue.use(Router)

const router = new Router({
    //mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            redirect: 'redirect',
            component: () => import( /* webpackChunkName: "redirect" */  /* webpackMode: "lazy" */ /* webpackPreconnect: true */ /* webpackPreload: true */ '@/layouts/Main'),
            children: [
                {
                    path: 'redirect',
                    component: () => import(/* webpackChunkName: "redirect" */  /* webpackMode: "lazy" */ /* webpackPreconnect: true */ /* webpackPreload: true */ '@/views/pages/Redirect'),
                },
                {
                    path: 'page404',
                    component: () => import(/* webpackChunkName: "page404" */  /* webpackMode: "lazy" */ /* webpackPreconnect: true */ /* webpackPreload: true */ '@/views/pages/Error404'),
                },
                
                {
                    path: 'list',
                    component: () => import(/* webpackChunkName: "list" */  /* webpackMode: "lazy" */ /* webpackPreconnect: true */ /* webpackPreload: true */ '@/views/pages/List'),
                },

                {
                    path: 'leaderboard/:id',
                    component: () => import(/* webpackChunkName: "leaderboard" */  /* webpackMode: "lazy" */ /* webpackPreconnect: true */ /* webpackPreload: true */ '@/views/pages/Leaderboard'),
                    children:[
                        {
                            name: 'leaderboard-widget',
                            path: 'widget',
                            component: () => import(/* webpackChunkName: "leaderboard_widget" */  /* webpackMode: "lazy" */ /* webpackPreconnect: true */ /* webpackPreload: true */ '@/components/LeaderBoard/Widget'),
                        },
                        {
                            name: 'leaderboard-detail',
                            path: 'detail',
                            component: () => import(/* webpackChunkName: "leaderboard_page" */  /* webpackMode: "lazy" */ /* webpackPreconnect: true */ /* webpackPreload: true */ '@/components/LeaderBoard/Detail'),
                        }
                    ]
                },
                
                {
                    path: ':ic_url',
                    component: () => import(/* webpackChunkName: "ic_url" */  /* webpackMode: "lazy" */ /* webpackPreconnect: true */ /* webpackPreload: true */ '@/views/pages/Interactive'),
                    children:[
                        {
                            name: 'login',
                            path: 'login',
                            component: () => import(/* webpackChunkName: "login" */  /* webpackMode: "lazy" */ /* webpackPreconnect: true */ /* webpackPreload: true */ '@/views/pages/Login'),
                        },
                        {
                            name: 'cover',
                            path: 'cover',
                            component: () => import(/* webpackChunkName: "cover" */  /* webpackMode: "lazy" */ /* webpackPreconnect: true */ /* webpackPreload: true */ '@/views/pages/Cover'),
                            meta: {
                                middleware: [
                                    scheduled
                                ]
                            }
                        },
                        {
                            name: 'intro',
                            path: 'intro',
                            component: () => import(/* webpackChunkName: "intro" */  /* webpackMode: "lazy" */ /* webpackPreconnect: true */ /* webpackPreload: true */ '@/views/pages/Intro'),
                            meta: {
                                middleware: [
                                    scheduled
                                ]
                            }
                        },
                        {
                            name: 'profiling',
                            path: 'profiling',
                            component: () => import(/* webpackChunkName: "profiling" */  /* webpackMode: "lazy" */ /* webpackPreconnect: true */ /* webpackPreload: true */ '@/views/pages/Profiling'),
                            meta: {
                                middleware: [
                                    scheduled, auth
                                ]
                            },
                        },
                        {
                            name: 'form',
                            path: 'form',
                            component: () => import(/* webpackChunkName: "form" */  /* webpackMode: "lazy" */ /* webpackPreconnect: true */ /* webpackPreload: true */ '@/views/pages/FormCombine'),
                            meta: {
                                middleware: [
                                    scheduled, auth
                                ]
                            },
                        },
                        {
                            name: 'question',
                            path: 'question',
                            component: () => import(/* webpackChunkName: "question" */  /* webpackMode: "lazy" */ /* webpackPreconnect: true */ /* webpackPreload: true */ '@/views/pages/Question'),
                            meta: {
                                middleware: [
                                    scheduled, auth
                                ]
                            },
                        },
                        {
                            name: 'result',
                            path: 'result',
                            component: () => import(/* webpackChunkName: "result" */  /* webpackMode: "lazy" */ /* webpackPreconnect: true */ /* webpackPreload: true */ '@/views/pages/Result'),
                            meta: {
                                middleware: [
                                    scheduled, auth
                                ]
                            },
                        },
                        {
                            name: 'unique',
                            path: 'unique',
                            component: () => import(/* webpackChunkName: "unique" */  /* webpackMode: "lazy" */ /* webpackPreconnect: true */ /* webpackPreload: true */ '@/views/pages/Unique'),                           
                        }
                    ]
                }
            ]
        },

    ],
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
})

router.beforeEach((to, from, next) => {
    if (!to.meta.middleware) {
        return next()
    }
    const middleware = to.meta.middleware

    const context = {
        to,
        from,
        next,
        store
    }

    return middleware[0]({
        ...context,
        next: middlewarePipeline(context, middleware, 1),
        nextVue: context.next
    })

})


export default router